"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamSubscriptionPricing = exports.TeamSubscriptionStatus = void 0;
var TeamSubscriptionStatus;
(function (TeamSubscriptionStatus) {
    TeamSubscriptionStatus["active"] = "active";
    TeamSubscriptionStatus["inactive"] = "inactive";
})(TeamSubscriptionStatus || (exports.TeamSubscriptionStatus = TeamSubscriptionStatus = {}));
var TeamSubscriptionPricing;
(function (TeamSubscriptionPricing) {
    TeamSubscriptionPricing["full_price"] = "full_price";
    TeamSubscriptionPricing["discount_50_percent"] = "discount_50_percent";
})(TeamSubscriptionPricing || (exports.TeamSubscriptionPricing = TeamSubscriptionPricing = {}));
